$(document).ready(function(){
    function normalizeVariantTitle(title) {
        return (title || '')
            .split('/')
            .map(function (s) { return s.trim().toLowerCase(); })
            .filter(function (s) { return s !== ''; })
            .sort()
            .join('|');
    }

    function getSelectedProductVariantId() {
        var variantId =
            $('product-info input[name="id"]').first().val() ||
            $('form[action*="/cart/add"] input[name="id"]').first().val();
        return variantId ? variantId.toString() : '';
    }

    function triggerSingleMonogrammingStyle() {
        var $styleOptions = $('.selection_box_single_main.monograming_style .select_single');
        if ($styleOptions.length == 1) {
            $styleOptions.first().trigger('click');
        }
    }

    function applyVariantInitialsOverride() {
        var selectedVariantId = getSelectedProductVariantId();
        var $dynamicContainer = $('.monogramming_initials_dynamic');
        var $templates = $('.monogramming_initials_templates');

        if ($dynamicContainer.length === 0 || $templates.length === 0) {
            return;
        }

        var $selectedTemplate = selectedVariantId
            ? $templates.find('template[data-monogramming-initials-template="' + selectedVariantId + '"]').first()
            : $();

        if ($selectedTemplate.length === 0) {
            $selectedTemplate = $templates.find('template[data-monogramming-initials-template="default"]').first();
        }

        if ($selectedTemplate.length === 0) {
            return;
        }

        var nextHtml = $selectedTemplate.html().trim();
        var currentHtml = $dynamicContainer.html().trim();

        if (nextHtml !== currentHtml) {
            $dynamicContainer.html(nextHtml);
        }

        setTimeout(function() {
            var selectedStyle = $('.monograming_style .monogramming_style_select.selected').attr('value');
            if (selectedStyle === 'Initials') {
                $('.selection_box_single_main.monograming_initials').show();
            }
            triggerSingleMonogrammingStyle();
        }, 0);
    }

    function n(v) {
        var x = parseFloat((v || "0").toString().replace(/,/g, ""));
        return isNaN(x) ? 0 : x;
    }

    function updateMonogrammingBasePrice() {
        var selectedVariantId = getSelectedProductVariantId();
        if (!selectedVariantId) return;

        var $variantPrice = $('.monogramming_variant_price_map [data-main-variant-id="' + selectedVariantId + '"]').first();
        if ($variantPrice.length === 0) return;

        var priceCents = $variantPrice.attr('data-main-variant-price');
        var compareCents = $variantPrice.attr('data-main-variant-compare');

        $('.monogramming_prd_total .total').attr('priceTotal', priceCents);
        $('.monogramming_prd_total .compare_total').attr('compareTotal', compareCents);
    }

    function refreshMonogrammingTotal() {
      // Build the selected monogram "title" to match a variant title
      var monogrammingPrdTitle = "";
      $('.selected_monogramming .variant_details .selection_box_single .selected').each(function () {
        var val = $(this).attr('value');
        if (val) {
          if (monogrammingPrdTitle !== "") monogrammingPrdTitle += " / ";
          monogrammingPrdTitle += val;
        }
      });

      // MAIN (base) amounts from attributes in your HTML
      var mainPrice   = n($('.monogramming_prd_total .total').attr('priceTotal')) / 100;
      var mainCompare = n($('.monogramming_prd_total .compare_total').attr('compareTotal')) / 100;

      // MONO (selected) amounts from the chosen variant line
      var monoPrice = 0;
      var monoCompare = 0;

      $('.selected_monogramming .variant_details_get .variant_details_single').each(function () {
        if ($(this).attr('vartitle') == monogrammingPrdTitle) {
          monoPrice = n($(this).attr('varPrice')) / 100;
          monoCompare = n($(this).attr('varCompare')) / 100;
        }
      });

      var totalPrice = (mainPrice + monoPrice);
      var totalCompare = (mainCompare + monoCompare);

      $('.monogramming_prd_total .total').text(totalPrice.toFixed(2));

      if (totalCompare > totalPrice) {
        $('.monogramming_prd_total .compare_total').text(totalCompare.toFixed(2));
        $('.monogramming_prd_total .compare-at-total').removeClass('hidden');
      } else {
        $('.monogramming_prd_total .compare-at-total').addClass('hidden');
      }
    }

    $(document).on('click', '.product-form__submit_monogramming', function(){
        setTimeout(() => {
            applyVariantInitialsOverride();
            $('.monogramming_popup_main').addClass('open');
            $('body').addClass('monogramming_open');
            $('.monogramming_main').addClass('open');
        }, 500);
        
    });
    $(document).on('click', '.monogramming_popup span.close_mono_popup', function(){
        $('.monogramming_popup_main').removeClass('open');
        setTimeout(() => {
            $('body').removeClass('monogramming_open');
            $('.monogramming_main').removeClass('open');
        },300)
        
    });
    $(document).click(function(e) {
        if (!$(e.target).closest('.monogramming_popup_main').length) {
            $('.monogramming_popup_main').removeClass('open');
            setTimeout(() => {
               $('body').removeClass('monogramming_open');
               $('.monogramming_main').removeClass('open');
            },300)
            
        }
    });
    $('#monogram_add').on('change', function() {
        if ($(this).is(':checked')) {
            applyVariantInitialsOverride();
            $('.product-form__submit_monogramming').removeClass('hidden');
            $('.product-form__submit').addClass('hidden');
            setTimeout(() => {
            $('.monogramming_popup_main').addClass('open');
            $('body').addClass('monogramming_open');
            $('.monogramming_main').addClass('open');
        }, 500);
        } else {
            $('.product-form__submit').removeClass('hidden');
            $('.product-form__submit_monogramming').addClass('hidden');
            $('.product-form form .monogram_text_box').remove();
        }
    });

    //* MONOGRAMMING STYLE SELECT START *//

    $(document).on('click', '.monogramming_style_select', function(){
        $(this).closest('.selection_box_single').find('.selected').removeClass('selected');
        $(this).addClass('selected'); 
        var current = $(this).attr('value');
        $('.monogram_sytle_properties').attr('value', current);
        if(current == 'Initials'){
           $('.selection_box_single_main.monograming_initials').show();
           $('.enter_your_name_box').removeClass('selected_monogramming');
           $('.monograming_name_date_time').removeClass('selected_monogramming');
           $('.monograming_design').removeClass('monograming_design_hide');
        }
        else if (current == 'Name'){
           $('.selection_box_single_main.monograming_initials').hide();
           $('.enter_your_name_box').addClass('selected_monogramming');
           $('.monograming_name_date_time').removeClass('selected_monogramming');
           $('.enter_your_initial_single').removeClass('selected_monogramming');
           $('.monogramming_initial_select').removeClass('selected');
           $('.monograming_design').removeClass('monograming_design_hide');
        }
        else if (current == 'Name, Date & Time'){
           $('.monograming_design .selection_box_single .select_single[value="Center"]').trigger('click');
           $('.selection_box_single_main.monograming_initials').hide();
           $('.enter_your_name_box').removeClass('selected_monogramming');
           $('.monograming_name_date_time').addClass('selected_monogramming');
           $('.enter_your_initial_single').removeClass('selected_monogramming');
           $('.monogramming_initial_select').removeClass('selected');
           $('.monograming_design').addClass('monograming_design_hide');
        }
        else {
           $('.selection_box_single_main.monograming_initials').hide();
           $('.enter_your_name_box').removeClass('selected_monogramming');
           $('.monograming_name_date_time').removeClass('selected_monogramming');
        }
          
    });

    //* MONOGRAMMING STYLE SELECT END *//


    $(document).on('click', '.monogramming_initial_select', function(){
        $(this).closest('.selection_box_single').find('.selected').removeClass('selected');
        $(this).addClass('selected'); 
        var initialCurrent = $(this).attr('value');
        $('.enter_your_initials_box').show();  
        $('.enter_your_initial_single').each(function(){
            var initialSingle = $(this).attr('value');
            if(initialSingle == initialCurrent){
                $(this).addClass('selected_monogramming');
            }else {
                $(this).removeClass('selected_monogramming');
            }
        })
    });
   
    $(document).on('click', '.variant_details .selection_box_single_main .select_single', function(){
        $(this).closest('.variant_details .selection_box_single').find('.selected').removeClass('selected');
        $(this).addClass('selected');
    });


    //* MONOGRAMMING ADD TO CART START *//
     $(document).on('click', '.product-form__submit_monogramming_popup', function(){
        
        var monogrammingPrdTitle = "";

        $('.selected_monogramming .variant_details .selection_box_single .selected').each(function () {
            var monogrammingValue = $(this).attr('value');

            if(monogrammingValue){
                // Add separator only if string already has content
                if(monogrammingPrdTitle !== ""){
                    monogrammingPrdTitle += " / ";
                }
                monogrammingPrdTitle += monogrammingValue;
            }
        });

            //alert(monogrammingPrdTitle);
           var monogrammingAddToCart = false;

            $('.selected_monogramming .main_property').each(function(){
                var thisVale = $(this).val();

                if(thisVale != ''){
                    monogrammingAddToCart = true;
                    $(this).next().hide();

                } else {
                    monogrammingAddToCart = false;
                    $(this).next().show();
                }
            });
            //alert(monogrammingAddToCart);
            if(monogrammingAddToCart === false){
                //alert("please enter")
            }else{
                
                var normalizedSelected = normalizeVariantTitle(monogrammingPrdTitle);
                $('.selected_monogramming .monogram_current_product').attr('value', '');
                $('.selected_monogramming .variant_details_get .variant_details_single').each(function(){

                var vartitle = $(this).attr('vartitle');
                if(normalizedSelected !== '' && normalizeVariantTitle(vartitle) === normalizedSelected){
                    var varid = $(this).attr('varid');
                    $(this).closest('.selected_monogramming').find('.monogram_current_product').attr('value', varid);
                }
                });
                var variantId = $('.selected_monogramming .monogram_current_product').attr('value');
                if(!variantId){
                    alert('Sorry, that combination of font and colour isn\'t available. Please choose a different combination.');
                    return;
                }
                var uniqueCode = "U-" + Date.now();
                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: {
                        id: variantId,
                        quantity: 1,
                        properties: {
                                "Monogramming": uniqueCode,
                                "Monogramming Product": "Yes",
                            }
                    },
                    dataType: 'json',
                    success: function (item) {
                        console.log(item);
                        $('.product-form form .monogram_text_box').remove();
                        var copyPropeties = $('.selected_monogramming .monogram_text_box').clone();
                        var copyPropetiesMonoStyle = $('.monogram_sytle_properties').clone();
                        var copyMessageMono = $('.monogramming_message').clone();
                        var propetiesMonoPositionLenght = $('.selection_box_single_main.monograming_design.monograming_design_hide').length;
                        // alert(propetiesMonoPositionLenght);
                        setTimeout(function(){
                            var selected_monogramming = $('.selected_monogramming');
                            
                            
                            $('.product-form form').prepend(`<input type="hidden" class="monogram_text_box" name="properties[Monogramming]" value="${uniqueCode}" />`);
                            $('.product-form form').prepend(copyMessageMono);
                            $('.product-form form').prepend(copyPropeties);
                            var propetiesMonoPosition = $('.monograming_design .monogram_postion_value').clone();
                            if(selected_monogramming.length>0){
                               if(propetiesMonoPositionLenght<1){
                                  $('.product-form form').prepend(propetiesMonoPosition); 
                               } 
                               
                            } 
                            $('.product-form form').prepend(copyPropetiesMonoStyle);
                            $('.product-form__submit').trigger('click');
                            //cartMonoGrammingUpdate()
                        },800);
                    },
                    error: function (xhr) {
                        var errorMessage = JSON.parse(xhr.responseText);
                        alert(errorMessage.description);
                    }
                });
            }
            
        
    });

    //* MONOGRAMMING ADD TO CART START *//


    $('.selection_box_single_main .select_single.selected').each(function(){
        selectedOptionValue = $(this).attr('value');
        $(this).closest('.selection_box_single_main').find('.selected_option_value').text(selectedOptionValue);
        $(this).closest('.selection_box_single_main').find('.monogram_option_vlaue').attr('value',selectedOptionValue);
        
    });

    $(document).on('click', '.selection_box_single_main .select_single', function(){
        selectedOptionValue = $(this).attr('value');
        $(this).closest('.selection_box_single_main').find('.selected_option_value').text(selectedOptionValue);
        $(this).closest('.selection_box_single_main').find('.monogram_option_vlaue').attr('value',selectedOptionValue);
    });

    $(document).on('input', '.main_property', function(){
        var elm = $(this);
        var thisVale = $(this).val();
        if(thisVale != ''){
            $(elm).next().hide();

        } else {
            $(elm).next().show();
        }
    });
    setInterval(function () {
      refreshMonogrammingTotal();
    }, 500);

    setInterval(function(){
        var getProductSoldOut = $('.product-form__submit_monogramming').attr('disabled');
        var selected_monogramming = $('.selected_monogramming');
        //alert(selected_monogramming.length)
        if(getProductSoldOut){
            $('.product-form__submit_monogramming_popup').attr('disabled', 'disabled');
        }else {
            $('.product-form__submit_monogramming_popup').removeAttr('disabled');
        }
        if(selected_monogramming.length>0){
        $('.product-form__submit_monogramming_popup_main, .monograming_design, .monogramming_prd_total').show();
        }else {
        $('.product-form__submit_monogramming_popup_main, .monograming_design, .monogramming_prd_total').hide();
        }
    },1000);  
    
    $(document).on('click', '.monograming_design .select_single', function(){
        $(this).closest('.monograming_design').find('.select_single.selected').removeClass('selected');
        $(this).addClass('selected');
        var monoSelectedPosition = $(this).attr('value');
        var monoSelectedPositionClass = $(this).attr('positionclass');
        $('.mono_img_position div').removeClass().addClass(monoSelectedPositionClass);
        $('.monograming_design .monogram_postion_value').attr('value', monoSelectedPosition);
    });

    var monoPosition = $('.monograming_design .select_single.selected').attr('value');
    $('.monograming_design .monogram_postion_value').attr('value', monoPosition);

    //* MONOGRAMMING APPEND IN IMAGE DESIGN START *//

$(document).on('input', '.selected_monogramming .main_property', function(){
    var selectedColorCode = $('.selected_monogramming .monograming_color .select_single.selected').attr('colorcode');
    var selectedStyle = $('.monogram_sytle_properties').val();

    setTimeout(function(){
        var $preview = $('.mono_img_position');
        var $inner = $preview.find('div');

        $preview.find('.preview-date, .preview-time').remove();
        $inner.find('.monogramming_text_img').remove();

        if (selectedStyle === 'Name, Date & Time') {
            var nameVal = $('.selected_monogramming .main_property[name="properties[Your Name]"]').val();
            var dateVal = $('.selected_monogramming .main_property[name="properties[Your Date]"]').val();
            var timeVal = $('.selected_monogramming .main_property[name="properties[Your Time]"]').val();

            if (nameVal) {
                $inner.append(`<span style="color: ${selectedColorCode};" class="monogramming_text_img preview-name">${nameVal}</span>`);
            }

            if (dateVal) {
                $preview.append(`<span style="color: ${selectedColorCode};" class="monogramming_text_img preview-date">${dateVal}</span>`);
            }

            if (timeVal) {
                $preview.append(`<span style="color: ${selectedColorCode};" class="monogramming_text_img preview-time">${timeVal}</span>`);
            }
        } else {
            $('.selected_monogramming .main_property').each(function(){
                var mainPropertyVal = $(this).val();

                if (mainPropertyVal !== "") {
                    $inner.append(`<span style="color: ${selectedColorCode};" class="monogramming_text_img">${mainPropertyVal}</span>`);
                }
            });
        }
    }, 500);
});


     //* MONOGRAMMING APPEND IN IMAGE DESIGN END *//

     //* MONOGRAMMING COLOR AND FONT UPDATE IN IMAGE DESIGN START *//

     $(document).on('click', '.selected_monogramming .monograming_color .select_single', function(){
         var colorSelectCode = $(this).attr('colorcode');
         $('.mono_img_position .monogramming_text_img').css('color', colorSelectCode);
        //  alert(colorSelectCode);
     });

     //* MONOGRAMMING COLOR AND FONT UPDATE IN IMAGE DESIGN END *//


    //*** MONOGRAMMING TRIGGER INITIALS START ***//
    $(document).on('click', '.monograming_initials .monogramming_initial_select',function(){
      setTimeout(function(){
        $('.monograming_initials .selected_monogramming .variant_details .select_single.selected').trigger('click');
      },500);  
      
    })
    //*** MONOGRAMMING TRIGGER INITIALS END ***//

    //* MONOGRAMMING EMPTY START *//
    $(document).on('click', '.monograming_style .monogramming_style_select', function () {
        $('.main_property').val('');
        $('.mono_img_position .monogramming_text_img').remove();
    });

    //* MONOGRAMMING EMPTY END *//

    //* CART UPDATE WITH MONOGRAMMING STRAT *//

    function markMonogrammingCartItems() {
        $('.cart-items .cart-item').each(function () {
            var $cartItem = $(this);
            var getMonogrammingPrd = $cartItem.find('.monogramming_product_yes');

            $cartItem.removeClass('monograming_prd_item_cart main_prd_item_cart');

            if (getMonogrammingPrd.length > 0) {
                $cartItem.addClass('monograming_prd_item_cart');
            } else {
                $cartItem.addClass('main_prd_item_cart');
            }
        });
    }

    function getCartRemoveControl($cartItem) {
        return $cartItem.find('.cart-remove-button, cart-remove-button a, cart-remove-button button').first();
    }

    var monogrammingCartSyncInProgress = false;

    function updateCartItemQuantity($cartItem, quantity) {
        var $cartComponent = $cartItem.closest('cart-items, cart-drawer-items');
        var lineIndex =
            $cartItem.find('cart-remove-button').first().data('index') ||
            $cartItem.find('.quantity__input').first().data('index');
        var cartItemKey = $cartItem.attr('data-cart-item-key');

        if (lineIndex === undefined && !cartItemKey) {
            window.location.reload();
            return;
        }

        var sections = [];
        if ($cartComponent.length > 0 && typeof $cartComponent.get(0).getSectionsToRender === 'function') {
            sections = $cartComponent
                .get(0)
                .getSectionsToRender()
                .map(function(section) {
                    return section.section;
                });
        }

        monogrammingCartSyncInProgress = true;

        fetch(routes.cart_change_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
            body: JSON.stringify({
                id: cartItemKey,
                line: lineIndex,
                quantity: quantity,
                sections: sections,
                sections_url: window.location.pathname
            })
        })
            .then(function(response) {
                return response.text();
            })
            .then(function() {
                if ($cartComponent.length > 0 && typeof $cartComponent.get(0).onCartUpdate === 'function') {
                    $cartComponent.get(0).onCartUpdate();
                } else {
                    window.location.reload();
                }
            })
            .catch(function() {
                window.location.reload();
            })
            .finally(function() {
                setTimeout(function () {
                    monogrammingCartSyncInProgress = false;
                }, 800);
            });
    }

    function removeCartItem($cartItem) {
        var $cartComponent = $cartItem.closest('cart-items, cart-drawer-items');
        var lineIndex =
            $cartItem.find('cart-remove-button').first().data('index') ||
            $cartItem.find('.quantity__input').first().data('index');
        var cartItemKey = $cartItem.attr('data-cart-item-key');

        if (lineIndex === undefined && !cartItemKey) {
            var $removeControl = getCartRemoveControl($cartItem);
            if ($removeControl.length > 0) {
                $removeControl.trigger('click');
            }
            return;
        }

        var sections = [];
        if ($cartComponent.length > 0 && typeof $cartComponent.get(0).getSectionsToRender === 'function') {
            sections = $cartComponent
                .get(0)
                .getSectionsToRender()
                .map(function(section) {
                    return section.section;
                });
        }

        fetch(routes.cart_change_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
            body: JSON.stringify({
                id: cartItemKey,
                line: lineIndex,
                quantity: 0,
                sections: sections,
                sections_url: window.location.pathname
            })
        })
            .then(function(response) {
                return response.text();
            })
            .then(function(state) {
                if ($cartComponent.length > 0 && typeof $cartComponent.get(0).onCartUpdate === 'function') {
                    $cartComponent.get(0).onCartUpdate();
                } else {
                    window.location.reload();
                }
            })
            .catch(function() {
                window.location.reload();
            });
    }

    setInterval(function(){
        markMonogrammingCartItems();
    },500);



    //cartMonoGrammingUpdate
    function cartMonoGrammingUpdate(){
        if (monogrammingCartSyncInProgress) {
            return;
        }

        setTimeout(function() {
            if (monogrammingCartSyncInProgress) {
                return;
            }

            markMonogrammingCartItems();

            var hasMismatch = false;

            $('.monograming_prd_item_cart .cart-item__details .monogramming_product_id').each(function () {
                if (hasMismatch || monogrammingCartSyncInProgress) {
                    return false;
                }

                var $monogrammingItem = $(this).closest('.cart-item');
                var monogrammingId = $(this).attr('monogrammingid');
                var monogrammingQty = parseInt($monogrammingItem.find('.quantity__input').first().val(), 10);
                var mainPrdValue;

                $('.main_prd_item_cart .cart-item__details .monogramming_product_id').each(function () {
                    var $mainItem = $(this).closest('.cart-item');
                    var nonMonogrammingId = $(this).attr('monogrammingid');

                    if (nonMonogrammingId == monogrammingId) {
                        mainPrdValue = parseInt($mainItem.find('.quantity__input').first().val(), 10);
                        return false;
                    }
                });

                if (!isNaN(mainPrdValue) && !isNaN(monogrammingQty) && mainPrdValue !== monogrammingQty) {
                    hasMismatch = true;
                    updateCartItemQuantity($monogrammingItem, mainPrdValue);
                    return false;
                }
            });
        }, 700);
    }

    function removeOrphanMonogrammingItems() {
        markMonogrammingCartItems();

        $('.monograming_prd_item_cart .cart-item__details .monogramming_product_id').each(function () {

            var mongrammingPrdDel = getCartRemoveControl($(this).closest('.cart-item'));

            var monogrammingId = $(this).attr('monogrammingid');

            var nextValues = [];

            // LOOP MAIN PRODUCTS
            $('.main_prd_item_cart .cart-item__details .monogramming_product_id').each(function () {

                var NonmonogrammingId = $(this).attr('monogrammingid');
                nextValues.push(NonmonogrammingId);

            });

            // DELETE IF NOT MATCHED
            if (nextValues.indexOf(monogrammingId) === -1) {
                removeCartItem($(this).closest('.cart-item'));
            }

        });

        $('.main_prd_item_cart .cart-item__details .monogramming_product_id').each(function () {
            var mainPrdDel = getCartRemoveControl($(this).closest('.cart-item'));
            var monogrammingId = $(this).attr('monogrammingid');
            var nextValues = [];

            // LOOP MONOGRAMMING PRODUCTS
            $('.monograming_prd_item_cart .cart-item__details .monogramming_product_id').each(function () {
                var monogrammingProductId = $(this).attr('monogrammingid');
                nextValues.push(monogrammingProductId);
            });

            // DELETE IF NOT MATCHED
            if (nextValues.indexOf(monogrammingId) === -1) {
                removeCartItem($(this).closest('.cart-item'));
            }
        });
    }

     setInterval(() => {
            removeOrphanMonogrammingItems();
            cartMonoGrammingUpdate();
        }, 3000);

        $(document).on('click', '.cart-item .cart-item__quantity-wrapper', function () {
            cartMonoGrammingUpdate();
        });

        $(document).on('change', '.cart-item quantity-input .quantity__input', function () {
            cartMonoGrammingUpdate();
        });

        $(document).on('click', '.cart-item .cart-remove-button, .cart-item quantity-input .quantity__button', function () {
            cartMonoGrammingUpdate();
            setTimeout(removeOrphanMonogrammingItems, 3000);
        });



    //* CART UPDATE WITH MONOGRAMMING END *//


    //* TRIGGER SINGLE MONOGRAMMING START *//

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, function () {
            setTimeout(function () {
                applyVariantInitialsOverride();
                updateMonogrammingBasePrice();
                refreshMonogrammingTotal();
            }, 50);
        });
    }

    $(document).on('change', 'product-info input[name="id"], form[action*="/cart/add"] input[name="id"]', function () {
        setTimeout(function () {
            applyVariantInitialsOverride();
            updateMonogrammingBasePrice();
            refreshMonogrammingTotal();
        }, 50);
    });

    applyVariantInitialsOverride();
    updateMonogrammingBasePrice();
    refreshMonogrammingTotal();

    triggerSingleMonogrammingStyle();


    //* TRIGGER SINGLE MONOGRAMMING END *//

    //* MONOGRAMMING INPUT CONVERT TO UPPER CASE START *//
       $(document).on('input', '.monogram_text_box_initials', function () {
            $(this).val($(this).val().toUpperCase());
       });  
       $(document).on('input', '.monogram_text_box_name', function () {
            $(this).val($(this).val().toUpperCase());
       }); 

    //* MONOGRAMMING INPUT CONVERT TO UPPER CASE END *//
   

    //* MONOGRAMMING FONT UPDATE START *//
      setInterval(()=> {
        var fontValue = $('.selected_monogramming .monograming_font .monograming_font_select.selected').attr('value');
        var fontClass = '';

        if (fontValue) {
          fontClass = 'font-' + fontValue.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
        }

        $('.mono_img_position')
          .css('font-family', fontValue)
          .removeClass(function(index, className) {
            return (className.match(/(^|\s)font-\S+/g) || []).join(' ');
          })
          .addClass(fontClass);
      },1000)
    //* MONOGRAMMING FONT UPDATE END *//

});
